import React from 'react'
import SideLogo from '../../Images/TopbarImg/Logo.png'
import Aos from 'aos'

const Mission = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='aboutus-body'>
                    <div className='aboutus-left' data-aos='fade-right'>
                        <img src={SideLogo} alt='Kanaklaxmi-Logo' />
                    </div>
                    <div className='aboutus-right' data-aos='fade-right'>
                        <div className='aboutus-body-1'>
                            <div className='aboutus-body-title'>
                                <h1>ध्येय (लक्ष्य)</h1>
                            </div>
                            <div className='aboutus-body-content'>
                                <p>“ सहकारी मुल्य, मान्यता र सिद्धान्तको आधारमा प्रविधि मैत्री वित्तीय तथा गैह्र वित्तीय सेवा मार्फत सदस्यहरूको आर्थिक जीवनस्तर उकास्ने ”</p>
                            </div>
                        </div>

                        <div className='aboutus-body-2'>
                            <div className='aboutus-body-title'>
                                <h1>Our Mission</h1>
                            </div>
                            <div className='aboutus-body-content'>
                                <p>“ To raise the financial standard of living of members through technology friendly financial and non-financial services based on cooperative values, beliefs and principles " </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default Mission